import React from "react";
import "./Our_objective.css";
import Common_title from "../../common-components/common-title/Common_title";

const Our_objective = () => {
  return (
    <>
      <section className="Our_Objectives">
        <div className="common_title_div">
          <Common_title title="OBJECTIVES" subtitle="Our Objectives" />
        </div>

        <div className="container">
          <div className="bg_img_holder">
            <img
              src={
                process.env.PUBLIC_URL +
                "/assets/images/about-us/our-objective/fruits.png"
              }
              className="bg_img"
              alt="Fruits Background"
            />

            <div className="content_div">
              <div className="row">
                {/* Vision */}
                <div className="col-md-6 mb-5">
                  <div className="white_card">
                    <div className="logo_img_holder">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/about-us/our-objective/vision.png"
                        }
                        className="logo_img"
                        alt="Vision Icon"
                      />
                    </div>
                    <p className="title">Our Vision</p>
                    <p className="dsecn">
                      Our vision is to create India’s most trusted local-first
                      marketplace app, where:
                    </p>
                    <ul className="abtcont">
                      <li>
                        Local businesses are preferred over online-only
                        platforms
                      </li>
                      <li>
                        Customers easily find nearby products and services
                      </li>
                      <li>Communication is direct, fast, and transparent</li>
                      <li>
                        Small businesses grow using technology without
                        complexity
                      </li>
                      <li>Local markets thrive in the digital age</li>
                      <li>
                        We aim to make “Nearby is Better” the new normal for
                        shopping and services
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Mission */}
                <div className="col-md-6 mb-5">
                  <div className="white_card">
                    <div className="logo_img_holder">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/about-us/our-objective/mission.png"
                        }
                        className="logo_img"
                        alt="Mission Icon"
                      />
                    </div>
                    <p className="title">Our Mission</p>
                    <p className="dsecn">
                      Our mission is to empower nearby local businesses by
                      giving them a strong digital platform that helps them
                      compete with large online marketplaces.
                    </p>
                    
                    <h5>Loconex is built to:</h5>
                    <ul className="abtcont">
                      <li>
                        Promote local shops, vendors, and service providers
                      </li>
                      <li>Help customers discover nearby businesses first</li>
                      <li>Enable direct inquiry, negotiation, and booking</li>
                      <li>
                        Provide WhatsApp-style chat between customers and
                        vendors, similar to IndiaMART, for quick communication
                        and trust building
                      </li>
                      <li>
                        Support local businesses with discounts, offers, and
                        digital visibility
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Our_objective;
